import { useEffect } from 'react';

export default function AlisonWidget({ usuario }) {
    useEffect(() => {
        // 1. Evitar inyecciones duplicadas si React renderiza dos veces
        if (document.getElementById('alison-widget-root')) return;

        // 2. Inyección de estilos de última generación
        const style = document.createElement('style');
        style.id = 'alison-widget-styles'; // Le ponemos ID para poder borrarlo al cerrar sesión
        style.innerHTML = `
            @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Fira+Code:wght@400;500&display=swap');
            
            #alison-transcript-box::-webkit-scrollbar { width: 5px; }
            #alison-transcript-box::-webkit-scrollbar-track { background: transparent; }
            #alison-transcript-box::-webkit-scrollbar-thumb { background: rgba(16, 185, 129, 0.3); border-radius: 4px; }

            @keyframes orbGlow { 0% { box-shadow: 0 0 25px rgba(16, 185, 129, 0.3); transform: scale(1); } 50% { box-shadow: 0 0 45px rgba(16, 185, 129, 0.7); transform: scale(1.06); } 100% { box-shadow: 0 0 25px rgba(16, 185, 129, 0.3); transform: scale(1); } }
            @keyframes wavePulse { 0% { height: 4px; } 50% { height: 22px; } 100% { height: 4px; } }
            @keyframes pulseGlow { 0% { box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.5); } 70% { box-shadow: 0 0 0 16px rgba(16, 185, 129, 0); } 100% { box-shadow: 0 0 0 0 rgba(16, 185, 129, 0); } }

            .alison-wave-bar { width: 3.5px; background: #10b981; border-radius: 3px; animation: wavePulse 1s infinite ease-in-out; display: inline-block; margin: 0 1.5px; }
            .alison-wave-bar:nth-child(2) { animation-delay: 0.15s; }
            .alison-wave-bar:nth-child(3) { animation-delay: 0.30s; }
            .alison-wave-bar:nth-child(4) { animation-delay: 0.45s; }
            .alison-wave-bar:nth-child(5) { animation-delay: 0.60s; }

            .typing-indicator { display: flex; align-items: center; gap: 5px; padding: 6px 10px; }
            .typing-dot { width: 7px; height: 7px; background: #10b981; border-radius: 50%; animation: bounce 1.4s infinite ease-in-out both; }
            .typing-dot:nth-child(1) { animation-delay: -0.32s; }
            .typing-dot:nth-child(2) { animation-delay: -0.16s; }
            @keyframes bounce { 0%, 80%, 100% { transform: scale(0); } 40% { transform: scale(1); } }

            .alison-mode-btn { background: rgba(30, 41, 59, 0.8); color: #94a3b8; border: 1px solid #334155; padding: 5px 12px; border-radius: 12px; font-size: 11px; cursor: pointer; transition: all 0.2s font-weight: 500; }
            .alison-mode-btn.active { background: rgba(16, 185, 129, 0.15); color: #10b981; border-color: #10b981; font-weight: 600; }
            .alison-action-btn:hover { background: rgba(16, 185, 129, 0.2) !important; color: #10b981 !important; transform: scale(1.05); }
        `;
        document.head.appendChild(style);

        const container = document.createElement('div');
        container.id = 'alison-widget-root'; // ID para controlarlo y destruirlo al salir
        container.style.position = 'fixed';
        container.style.bottom = '90px';
        container.style.right = '35px';  
        container.style.zIndex = '999999';
        container.style.fontFamily = '"Inter", system-ui, sans-serif';

        container.innerHTML = `
            <!-- VENTANA PRINCIPAL TOP PREMIUM -->
            <div id="alison-window" style="display: none; position: fixed; bottom: 160px; right: 35px; width: 410px; height: 620px; background: rgba(11, 15, 25, 0.96); backdrop-filter: blur(24px); border-radius: 24px; box-shadow: 0 25px 60px rgba(0,0,0,0.6), 0 0 1px 1px rgba(255,255,255,0.08); flex-direction: column; overflow: hidden; border: 1px solid rgba(16, 185, 129, 0.25); transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1); transform-origin: bottom right; z-index: 999999;">
                
                <!-- HEADER PREMIUM -->
                <div style="background: linear-gradient(180deg, rgba(15, 23, 42, 0.9) 0%, rgba(11, 15, 25, 0.5) 100%); color: #fff; padding: 16px 20px; border-bottom: 1px solid rgba(255,255,255,0.06); display: flex; justify-content: space-between; align-items: center;">
                    <div style="display: flex; align-items: center; gap: 12px;">
                        <div style="position: relative;">
                            <div id="alison-status-icon" style="width: 38px; height: 38px; border-radius: 50%; background: linear-gradient(135deg, #10b981 0%, #047857 100%); display: flex; justify-content: center; align-items: center; font-size: 18px; box-shadow: 0 0 15px rgba(16, 185, 129, 0.4);">
                                🧠
                            </div>
                            <span id="alison-online-dot" style="position: absolute; bottom: 0; right: 0; width: 9px; height: 9px; background: #10b981; border: 2px solid #0b0f19; border-radius: 50%;"></span>
                        </div>
                        <div>
                            <div style="font-size: 14px; font-weight: 700; letter-spacing: 0.6px; color: #f8fafc; display: flex; align-items: center; gap: 8px;">
                                ALISON
                                <span id="alison-role-badge" style="font-size: 9px; background: rgba(16, 185, 129, 0.15); color: #10b981; border: 1px solid rgba(16, 185, 129, 0.3); padding: 1px 6px; border-radius: 6px; font-weight: 600;">SOPORTE_DEV</span>
                            </div>
                            <div id="alison-status-text" style="font-size: 11px; color: #94a3b8; font-weight: 400; margin-top: 1px;">
                                Inteligencia Colmena Activa
                            </div>
                        </div>
                    </div>

                    <!-- SELECTOR DE VISTA: VOZ / TEXTO -->
                    <div style="display: flex; gap: 4px; background: rgba(15, 23, 42, 0.6); padding: 3px; border-radius: 14px; border: 1px solid #1e293b;">
                        <button id="btn-mode-voice" class="alison-mode-btn active" title="Pantalla de voz e interactividad">🎙️ Voz</button>
                        <button id="btn-mode-text" class="alison-mode-btn" title="Ver historial en texto">💬 Texto</button>
                        <button id="alison-close" style="background:none; border:none; color:#64748b; cursor:pointer; font-size: 16px; margin-left: 4px; padding: 0 4px;">✖</button>
                    </div>
                </div>

                <!-- VISTA 1: INTERFAZ NEURONAL DE VOZ -->
                <div id="alison-view-voice" style="flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 24px; position: relative; background: radial-gradient(circle at center, rgba(16, 185, 129, 0.05) 0%, transparent 70%);">
                    
                    <!-- ORB NEURONAL CENTRADO -->
                    <div id="alison-orb-container" style="position: relative; width: 130px; height: 130px; display: flex; align-items: center; justify-content: center; margin-bottom: 20px;">
                        <div id="alison-orb-glow" style="position: absolute; width: 120px; height: 120px; border-radius: 50%; background: radial-gradient(circle, rgba(16, 185, 129, 0.4) 0%, transparent 70%); animation: orbGlow 3s infinite ease-in-out;"></div>
                        <div id="alison-orb-core" style="width: 90px; height: 90px; border-radius: 50%; background: linear-gradient(135deg, #10b981 0%, #064e3b 100%); display: flex; align-items: center; justify-content: center; font-size: 38px; border: 2px solid rgba(52, 211, 153, 0.5); box-shadow: inset 0 0 20px rgba(255,255,255,0.2); z-index: 2;">
                        </div>
                    </div>

                    <!-- ONDA DE AUDICIÓN -->
                    <div id="alison-voice-wave" style="display: none; height: 24px; align-items: center; margin-bottom: 16px;">
                        <div class="alison-wave-bar"></div>
                        <div class="alison-wave-bar"></div>
                        <div class="alison-wave-bar"></div>
                        <div class="alison-wave-bar"></div>
                        <div class="alison-wave-bar"></div>
                    </div>

                    <!-- SUBTÍTULO EN VIVO -->
                    <div id="alison-live-caption" style="width: 100%; background: rgba(15, 23, 42, 0.7); border: 1px solid rgba(255, 255, 255, 0.08); border-radius: 16px; padding: 14px 16px; color: #e2e8f0; font-size: 13px; text-align: center; line-height: 1.5; min-height: 65px; display: flex; align-items: center; justify-content: center; box-shadow: inset 0 2px 4px rgba(0,0,0,0.3);">
                        "¡Red neuronal lista! Háblame o escríbeme lo que necesites y me encargo."
                    </div>
                </div>

                <!-- VISTA 2: TRANSCIPCIÓN COMPLETA EN TEXTO -->
                <div id="alison-view-text" style="display: none; flex: 1; padding: 18px; overflow-y: auto; flex-direction: column; gap: 14px; scroll-behavior: smooth;">
                    <div style="background: rgba(30, 41, 59, 0.6); color: #cbd5e1; padding: 12px 14px; border-radius: 4px 14px 14px 14px; font-size: 13px; align-self: flex-start; max-width: 88%; border: 1px solid #334155; line-height: 1.4;">
                        Registro de conversación activado.
                    </div>
                </div>

                <!-- FOOTER CON ENTRADA DE TEXTO -->
                <form id="alison-form" style="display: flex; padding: 14px 18px; background: rgba(15, 23, 42, 0.95); border-top: 1px solid rgba(255, 255, 255, 0.06); gap: 10px; align-items: center;">
                    <input type="file" id="alison-file-input" style="display: none;" accept=".pdf,.docx,.xlsx,.csv,.txt,.js,.json,.py" />
                    
                    <button type="button" id="alison-attach-trigger" class="alison-action-btn" title="Adjuntar documento" style="background: rgba(30, 41, 59, 0.8); color: #94a3b8; border: 1px solid #334155; border-radius: 50%; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; flex-shrink: 0;">
                        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path>
                        </svg>
                    </button>

                    <input id="alison-input" type="text" placeholder="Escribe tu consulta..." style="flex: 1; padding: 11px 15px; border: 1px solid #334155; border-radius: 20px; outline: none; font-size: 13px; background: rgba(11, 15, 25, 0.8); color: #f8fafc;" autocomplete="off" />
                    
                    <button type="submit" class="alison-action-btn" style="background: linear-gradient(135deg, #10b981 0%, #047857 100%); color: white; border: none; width: 40px; height: 40px; border-radius: 50%; cursor: pointer; display: flex; align-items: center; justify-content: center; box-shadow: 0 4px 16px rgba(16, 185, 129, 0.4); flex-shrink: 0;">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg>
                    </button>
                </form>
            </div>

            <!-- BOTÓN FLOTANTE PRINCIPAL -->
            <button id="alison-trigger" style="width: 58px; height: 58px; border-radius: 50%; background: linear-gradient(135deg, #0b0f19 0%, #1e293b 100%); color: #10b981; border: 2px solid #10b981; font-size: 25px; cursor: pointer; display: flex; align-items: center; justify-content: center; box-shadow: 0 10px 30px rgba(0,0,0,0.5), 0 0 15px rgba(16, 185, 129, 0.3); animation: pulseGlow 3s infinite; transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);">
                🌟
            </button>
        `;
        document.body.appendChild(container);

        // REFERENCIAS DEL DOM
        const btnTrigger = document.getElementById('alison-trigger');
        const btnClose = document.getElementById('alison-close');
        const windowChat = document.getElementById('alison-window');
        const form = document.getElementById('alison-form');
        const input = document.getElementById('alison-input');
        
        const viewVoice = document.getElementById('alison-view-voice');
        const viewText = document.getElementById('alison-view-text');
        const btnModeVoice = document.getElementById('btn-mode-voice');
        const btnModeText = document.getElementById('btn-mode-text');
        
        const liveCaption = document.getElementById('alison-live-caption');
        const voiceWave = document.getElementById('alison-voice-wave');
        const orbCore = document.getElementById('alison-orb-core');
        
        const fileInput = document.getElementById('alison-file-input');
        const btnAttach = document.getElementById('alison-attach-trigger');

        let capacidadesFisicas = { voz_activa: false };

        // CAMBIO ENTRE MODO VOZ Y MODO TEXTO
        btnModeVoice.onclick = () => {
            btnModeVoice.classList.add('active');
            btnModeText.classList.remove('active');
            viewVoice.style.display = 'flex';
            viewText.style.display = 'none';
        };

        btnModeText.onclick = () => {
            btnModeText.classList.add('active');
            btnModeVoice.classList.remove('active');
            viewText.style.display = 'flex';
            viewVoice.style.display = 'none';
            viewText.scrollTop = viewText.scrollHeight;
        };

        const verificarEstadoFisico = async () => {
            try {
                const res = await fetch('http://localhost:4000/api/alison/estado-fisico');
                const data = await res.json();
                if (data.success) capacidadesFisicas = data.capacidades;
            } catch (e) {}
        };
        verificarEstadoFisico();

        const hablar = async (textoLimpio) => {
            liveCaption.innerText = `"${textoLimpio}"`;
            if (!capacidadesFisicas.voz_activa) return;
            try {
                voiceWave.style.display = 'flex';
                orbCore.style.transform = 'scale(1.15)';
                const res = await fetch('http://localhost:4000/api/alison/hablar', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ texto: textoLimpio })
                });
                if (!res.ok) throw new Error();
                const blob = await res.blob();
                const audio = new Audio(URL.createObjectURL(blob));
                audio.onended = () => { 
                    voiceWave.style.display = 'none';
                    orbCore.style.transform = 'scale(1)';
                };
                audio.play();
            } catch (err) {
                voiceWave.style.display = 'none';
                orbCore.style.transform = 'scale(1)';
            }
        };

        const toggleChat = () => { 
            if (windowChat.style.display === 'none' || windowChat.style.display === '') {
                windowChat.style.display = 'flex';
                setTimeout(() => {
                    windowChat.style.opacity = '1';
                    windowChat.style.transform = 'scale(1) translateY(0)';
                    input.focus();
                }, 10);
                btnTrigger.style.transform = 'scale(0) rotate(180deg)';
            } else {
                windowChat.style.opacity = '0';
                windowChat.style.transform = 'scale(0.95) translateY(20px)';
                setTimeout(() => { windowChat.style.display = 'none'; }, 300);
                btnTrigger.style.transform = 'scale(1) rotate(0deg)';
            }
        };
        
        windowChat.style.opacity = '0';
        windowChat.style.transform = 'scale(0.95) translateY(20px)';
        btnTrigger.onclick = toggleChat;
        btnClose.onclick = toggleChat;

        const parseMarkdown = (text) => {
            let html = text.replace(/```(\w+)?\n([\s\S]*?)```/g, '<div style="background: #0f172a; padding: 10px; border-radius: 8px; margin: 8px 0; font-family: \'Fira Code\', monospace; font-size: 12px; overflow-x: auto; border: 1px solid #334155; color: #34d399;">$2</div>');
            html = html.replace(/`([^`]+)`/g, '<span style="background: rgba(51, 65, 85, 0.6); color: #6ee7b7; padding: 2px 5px; border-radius: 4px; font-family: \'Fira Code\', monospace; font-size: 12px;">$1</span>');
            html = html.replace(/\*\*([^*]+)\*\*/g, '<strong style="color: #fff;">$1</strong>');
            html = html.replace(/\n/g, '<br>');
            return html;
        };

        const addTranscript = (text, isUser) => {
            const msg = document.createElement('div');
            msg.style.padding = '12px 14px';
            msg.style.fontSize = '13px';
            msg.style.maxWidth = '88%';
            msg.style.lineHeight = '1.4';
            
            if (isUser) {
                msg.style.background = 'linear-gradient(135deg, #10b981 0%, #059669 100%)'; 
                msg.style.color = 'white'; 
                msg.style.alignSelf = 'flex-end';
                msg.style.borderRadius = '14px 4px 14px 14px'; 
                msg.innerHTML = text;
            } else {
                msg.style.background = 'rgba(30, 41, 59, 0.7)'; 
                msg.style.color = '#e2e8f0'; 
                msg.style.alignSelf = 'flex-start';
                msg.style.borderRadius = '4px 14px 14px 14px'; 
                msg.style.border = '1px solid #334155';
                msg.innerHTML = parseMarkdown(text);
            }
            viewText.appendChild(msg);
            viewText.scrollTop = viewText.scrollHeight;
        };

        btnAttach.onclick = () => fileInput.click();

        fileInput.onchange = async (e) => {
            const file = e.target.files[0];
            if (!file) return;

            liveCaption.innerText = `📎 Leyendo documento: ${file.name}...`;
            addTranscript(`📎 Enviando documento: ${file.name}...`, true);

            const formData = new FormData();
            formData.append('archivo', file);

            try {
                const res = await fetch('http://localhost:4000/api/alison/leer-documento', {
                    method: 'POST',
                    body: formData
                });
                const data = await res.json();
                if (data.success) {
                    addTranscript(data.message, false);
                    hablar(data.message);
                } else {
                    liveCaption.innerText = "⚠️ Error al procesar el archivo.";
                }
            } catch (err) {
                liveCaption.innerText = "⚠️ Error de comunicación con el motor de archivos.";
            } finally {
                fileInput.value = ''; 
            }
        };

        form.onsubmit = async (e) => {
            e.preventDefault();
            const texto = input.value.trim();
            if (!texto) return;
            
            input.value = '';
            liveCaption.innerText = "Consultando en el sistema...";
            addTranscript(texto, true);

            try {
                const res = await fetch('http://localhost:4000/api/claude/chat', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ mensaje: texto })
                });
                const data = await res.json();
                if (data.respuesta) {
                    const respuestaLimpia = data.respuesta;
                    addTranscript(respuestaLimpia, false);
                    hablar(respuestaLimpia);
                } else if (data.error) {
                    liveCaption.innerText = "⚠️ " + data.error;
                    addTranscript("⚠️ " + data.error, false);
                }
            } catch (err) {
                console.error(err);
                liveCaption.innerText = "⚠️ Servidor no disponible (Puerto 4000).";
                addTranscript("⚠️ Servidor no disponible (Puerto 4000).", false);
            }
        };

        // 3. FUNCIÓN DE LIMPIEZA MÁGICA: Se ejecuta sola al hacer Logout o cuando el componente se desmonta
        return () => {
            const widget = document.getElementById('alison-widget-root');
            if (widget) widget.remove();
            
            const styles = document.getElementById('alison-widget-styles');
            if (styles) styles.remove();
        };
    }, [usuario]); 

    return null; // Todo se inyecta directamente al DOM, por lo que React no necesita renderizar HTML aquí
}